import { render, staticRenderFns } from "./5year.vue?vue&type=template&id=08d35347&scoped=true&"
import script from "./5year.vue?vue&type=script&lang=ts&"
export * from "./5year.vue?vue&type=script&lang=ts&"
import style0 from "./5year.vue?vue&type=style&index=0&id=08d35347&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d35347",
  null
  
)

export default component.exports